module.exports = __webpack_public_path__ + "img/info.3da0f0c4.svg";